import {
  STEP_FIND_YOUR_BUSINESS,
  WIZARD_STEPS
} from '../steps/wizard-steps-description';
import AbstractSessionModel from './AbstractSessionModel';
import Observable from '../decorators/Observable';
import StoreFieldInSession from '../decorators/StoreFieldInSession';
import Action from '../decorators/Action';
import IStep from '../lib/IStep';
import { runInAction } from 'mobx';

export type ISteps = {
  [stepName: string]: {
    component: any;
    possibleNextSteps: string[];
    step: IStep;
    group: string;
    style: {
      visibleInformationPanel: boolean;
    };
  };
} | null;

class StepperModel extends AbstractSessionModel {
  @StoreFieldInSession()
  @Observable()
  public currentStep: string | null = STEP_FIND_YOUR_BUSINESS;

  currentStepStack = [];

  constructor() {
    super();
    super.initFields();
  }

  @Action()
  changeStep(stepName: string) {
    this.currentStep = stepName;
    this.currentStepStack.push(stepName);
  }

  @Action()
  async firstNextStepFromPossibleNextSteps() {
    let currentStep = WIZARD_STEPS[this.currentStep];

    if (currentStep) {
      if (currentStep.possibleNextSteps.length > 0) {
        const nextStapeName = currentStep.possibleNextSteps[0];

        if (
          typeof WIZARD_STEPS[nextStapeName].step.onBeforeInit === 'function'
        ) {
          await WIZARD_STEPS[nextStapeName].step.onBeforeInit();
        }

        runInAction(() => {
          this.currentStep = nextStapeName;
          this.currentStepStack.push(this.currentStep);
        });
      }
    }
  }

  @Action()
  nextStep(nextStep: string) {
    let currentStep = WIZARD_STEPS[this.currentStep];

    if (currentStep) {
      if (
        currentStep.possibleNextSteps.length > 0 &&
        currentStep.possibleNextSteps.includes(nextStep)
      ) {
        this.currentStep = nextStep;
        this.currentStepStack.push(nextStep);
      }
    }
  }

  @Action()
  prevStep() {
    this.currentStepStack.pop();
    this.currentStep = this.currentStepStack[this.currentStepStack.length - 1];
  }

  getSessionKey(): string {
    return 'Stepper';
  }
}

export default new StepperModel();
